import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { FullPageWrapper, SpinnerLoader } from 'shared/ui'
import { RcsProvider, useRcsContext } from 'pages/settings/pages/rcs/context/rcsContext'
import { RcsEmpty } from '../RcsEmpty'
import { RcsInfo } from '../RcsInfo'

import styles from './styles.module.scss'

const Rcs = observer(() => {
  const [initialLoading, isInitialLoading] = useState(true)
  const { init, isEmpty, loading } = useRcsContext()

  useEffect(() => {
    init().then(() => isInitialLoading(false))
  }, [])

  if (initialLoading || loading) return <SpinnerLoader ariaLabel={'RcsPage'} />
  if (!initialLoading && !loading && isEmpty) return <RcsEmpty />

  return <RcsInfo />
})

export const RcsPage = observer(() => (
  <FullPageWrapper className={styles.page}>
    <RcsProvider>
      <Rcs />
    </RcsProvider>
  </FullPageWrapper>
))
